import Image from 'next/image'
import { Media } from './shopdetails'

interface Props {
  media?: Media
  alt: string
}

export default function ProjectMedia({ media, alt }: Props) {
  if (!media) {
    return (
      <Image
        src="/placeholder.webp"
        alt="placeholder"
        fill
        className="object-cover"
      />
    )
  }

  if (media.type === 'image') {
    return (
      <Image
        src={media.src}
        alt={alt}
        fill
        className="object-cover"
        priority
      />
    )
  }

  if (media.type === 'video') {
    return (
      <video
        src={media.src}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        className="absolute inset-0 w-full h-full object-cover"
      />
    )
  }

  return null
}
